/** System audit log [362:2271](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=362-2271) */
export const ADMIN_AUDIT_LOG_PATH = '/admin/audit-log'

export const ADMIN_AUDIT_LOG = {
  title: 'System Audit Log',
  subtitle: 'Immutable record of administrative actions.',
  dateRangeLabel: 'Last 7 Days',
  loadMoreLabel: 'Load More Records',
  tabs: [
    { id: 'all', label: 'All' },
    { id: 'orders', label: 'Orders' },
    { id: 'users', label: 'Users' },
    { id: 'merchants', label: 'Merchants' },
  ],
  columns: {
    admin: 'Admin',
    action: 'Action',
    entity: 'Entity',
    changeState: 'Change State (Before → After)',
    ipTime: 'IP / Time',
  },
  entries: [
    {
      id: '1',
      category: 'orders',
      accent: 'modified',
      admin: { name: 'J. Doe', id: 'ADM-902', initials: 'JD', avatar: true },
      actionType: 'modified',
      actionLabel: 'MODIFIED',
      actionDescription: 'Order Status Update',
      entityId: 'ORD-2023-8991',
      before: { label: 'Pending', tone: 'muted' },
      after: { label: 'Fulfilled', tone: 'success' },
      ip: '192.168.1.45',
      time: '10:42 AM, Today',
    },
    {
      id: '2',
      category: 'users',
      accent: 'deleted',
      admin: { name: 'S. Miller', id: 'ADM-114', initials: 'SM' },
      actionType: 'deleted',
      actionLabel: 'DELETED',
      actionDescription: 'Removed User Account',
      entityId: 'USR-441-X',
      before: { label: 'Active Profile', tone: 'muted' },
      after: { label: 'Null', tone: 'muted', italic: true },
      ip: '10.0.0.12',
      time: '09:15 AM, Today',
    },
    {
      id: '3',
      category: 'merchants',
      accent: 'created',
      admin: { name: 'A. Khan', id: 'ADM-005', initials: 'AK' },
      actionType: 'created',
      actionLabel: 'CREATED',
      actionDescription: 'New Merchant Onboarded',
      entityId: 'MCH-Global-LLC',
      before: { label: 'Null', tone: 'null', italic: true },
      after: { label: 'Init_State', tone: 'muted' },
      ip: '172.16.254.1',
      time: 'Yesterday, 16:30',
    },
  ],
  mobileTitle: 'Admin Audit Log',
  mobileSearchPlaceholder: 'Search by admin, action, or entity...',
  mobileDateFromPlaceholder: 'mm/dd/yyyy',
  mobileDateToPlaceholder: 'mm/dd/yyyy',
  mobileLoadMoreLabel: 'Load More Logs',
  mobileFilters: [
    { id: 'all', label: 'All Events' },
    { id: 'orders', label: 'Orders' },
    { id: 'users', label: 'Users' },
    { id: 'merchants', label: 'Merchants' },
  ],
  mobileGroups: [
    {
      id: 'today',
      label: 'Today',
      entries: [
        {
          id: 'audit-mob-1',
          category: 'users',
          actor: {
            name: 'Sarah Jenkins',
            initials: 'SJ',
            avatarTone: 'rose',
          },
          actionType: 'banned',
          accentColor: '#B61722',
          badgeIcon: 'ban',
          badgeColor: '#B61722',
          message: {
            template: '{actor} banned user {entity}',
            entity: 'Jane Doe',
            entityTone: 'red',
          },
          description: 'Reason: Violation of Terms of Service (Sec 4.2)',
          time: '10:42 AM',
        },
        {
          id: 'audit-mob-2',
          category: 'orders',
          actor: {
            name: 'System Auto-Cancel',
            isSystem: true,
            systemIcon: 'clipboard',
          },
          actionType: 'cancelled',
          accentColor: '#6A4200',
          badgeIcon: 'clipboardX',
          badgeColor: '#6A4200',
          message: {
            template: '{actor} cancelled Order {entity}',
            entity: '#8921',
            entityTone: 'orange',
          },
          description: 'Reason: Payment timeout exceeded (15m)',
          time: '09:15 AM',
        },
        {
          id: 'audit-mob-3',
          category: 'merchants',
          actor: {
            name: 'Michael Chen',
            initials: 'MC',
            avatarTone: 'blue',
          },
          actionType: 'updated',
          accentColor: '#2419E9',
          accentOpacity: 0.5,
          badgeIcon: 'pencil',
          badgeColor: '#2419E9',
          message: {
            template: '{actor} updated global setting {entity}',
            entity: 'Delivery Fee',
            entityTone: 'indigo',
          },
          description: 'Changed from ₦4.99 to ₦5.49',
          time: '08:03 AM',
        },
      ],
    },
    {
      id: 'yesterday',
      label: 'Yesterday',
      entries: [
        {
          id: 'audit-mob-4',
          category: 'merchants',
          actor: {
            name: 'Admin API',
            isSystem: true,
            systemIcon: 'store',
          },
          actionType: 'approved',
          accentColor: '#E1E3E4',
          badgeIcon: 'check',
          badgeColor: '#767588',
          message: {
            template: '{actor} approved merchant onboarding {entity}',
            entity: 'Burger King (Westside)',
            entityTone: 'default',
          },
          description: 'Documents verified via 3rd party KYC provider.',
          time: '11:45 PM',
        },
        {
          id: 'audit-mob-5',
          category: 'orders',
          actor: {
            name: 'Elena Rodriguez',
            initials: 'ER',
            avatarTone: 'amber',
          },
          actionType: 'refund',
          accentColor: '#2419E9',
          accentOpacity: 0.5,
          badgeIcon: 'wallet',
          badgeColor: '#2419E9',
          message: {
            template: '{actor} initiated manual refund for Order {entity}',
            entity: '#8802',
            entityTone: 'indigo',
          },
          description: 'Amount: ₦42.50. Note: Customer reported missing items.',
          time: '04:20 PM',
        },
      ],
    },
  ],
}
